import type { PipelineRunDto, ProjectStage } from "../../types/index.ts";

const relative = new Intl.RelativeTimeFormat("sv", { numeric: "auto" });

export function ago(iso: string, now = Date.now()): string {
  const seconds = Math.round((new Date(iso).getTime() - now) / 1000);
  const abs = Math.abs(seconds);
  if (abs < 60) return relative.format(Math.round(seconds), "second");
  if (abs < 3600) return relative.format(Math.round(seconds / 60), "minute");
  if (abs < 86_400) return relative.format(Math.round(seconds / 3600), "hour");
  return relative.format(Math.round(seconds / 86_400), "day");
}

/** Where the project's last deploy stands, as the person would ask about it. */
export function runText(run: PipelineRunDto, now = Date.now()): string {
  const where = run.branch === "main" ? "produktion" : "testmiljön";
  switch (run.state) {
    case "queued":
      return `Väntar på att läggas upp i ${where}`;
    case "running":
      return `Läggs upp i ${where} just nu`;
    case "succeeded":
      return `Uppe i ${where}${run.finishedAt ? ` · ${ago(run.finishedAt, now)}` : ""}`;
    case "failed":
      return `Senaste uppläggningen misslyckades${run.finishedAt ? ` · ${ago(run.finishedAt, now)}` : ""}`;
    case "canceled":
      return "Senaste uppläggningen avbröts";
  }
}

/** What pressing "Lägg upp i testmiljön" would take there. */
export function unpublishedText(count: number): string {
  return count === 1 ? "1 sparad ändring som inte ligger i testmiljön än" : `${count} sparade ändringar som inte ligger i testmiljön än`;
}

export function stageText(stage: ProjectStage): string {
  return stage === "mvp"
    ? "MVP — riktiga användare, både test- och produktionsmiljö"
    : "POC — bevisar en idé på påhittad data, bara testmiljö";
}
